import { format } from 'date-fns';
import { firstLetterUpper } from '../../utils/formaters';
export const transformAvailabilityCardDto = (dto) => {
    return {
        fleetAvailability: dto.disponibilidade || 0,
        activeFleet: dto.frotaAtiva || 0,
        availableFleet: dto.frotaDisponivel || 0,
        effectiveFleet: dto.frotaEfetiva || 0,
        totalInMaintenance: dto.totalManutencao || 0,
        stopped: dto.parado || 0,
        running: dto.rodando || 0,
        reserveFleet: dto.frotaReserva || 0,
        reserveInUse: dto.reservaEmUso || 0,
    };
};
export const transformAvailabilityListItensDto = (dto) => {
    return dto.map(item => ({
        licensePlate: item.placaVetor || '-',
        chassi: item.chassi || '-',
        type: item.tipoVeiculo || '-',
        branch: item.clienteIndicadores || '-',
        reasonForOs: item.motivoAtendimento === 'NULL'
            ? '-'
            : firstLetterUpper(item.motivoAtendimento),
        daysInMaintenance: item.diasManutencao || '-',
        reservePlate: item.placaReserva === 'NULL' ? '-' : item.placaReserva || '-',
        reserve: item.placaReserva === 'NULL'
            ? '-'
            : firstLetterUpper(item.reservaEmpenhado) || '-',
    }));
};
export const transformAvailabilityListDto = (tableLogs) => ({
    itens: transformAvailabilityListItensDto(tableLogs.Data),
    pageCount: tableLogs.TotalPaginas,
    rows: tableLogs.TotalTamanho,
});
export const transformPreventiveCardDto = (dto) => {
    return {
        preventives: dto.preventivas || 0,
        onTime: dto.emDia,
        dueSoon: dto.aVencer,
        overdue: dto.vencida || 0,
        totalInMaintenance: dto.totalManutencao || 0,
        stopped: dto.parado || 0,
        running: dto.rodando || 0,
    };
};
export const transformPreventiveListItensDto = (dto) => {
    return dto.map(item => ({
        id: item.statusPreventiva !== 'EM DIA' ? item.placaVetor : null,
        licensePlate: item.placaVetor || '-',
        chassis: item.chassi || '-',
        currentKm: item.kmAtual || '-',
        lastServiceDate: format(new Date(item.dataProximaRevisao), 'dd/MM/yyyy') || '-',
        lastServiceKm: item.kmUltimaRevisao || '-',
        preventiveStatus: firstLetterUpper(item.statusPreventiva),
        intervalKm: item.intervaloKM || '-',
        intervalDays: item.intervaloTempo || '-',
    }));
};
export const transformPreventiveListDto = (tableLogs) => ({
    itens: transformPreventiveListItensDto(tableLogs.Data),
    pageCount: tableLogs.TotalPaginas,
    rows: tableLogs.TotalTamanho,
});
